import React, { useContext, createContext, useState } from "react";

const clientUsersFormContext = createContext();

export const ProvideClientUsersForm = ({ children }) => {
  	// state for use with client users form context
	const [selectedClientUsers , _setSelectedClientUsers ] = useState(null);
	const [selectedClientUserIds, setSelectedClientUserIds] = useState(getEditingClientUsersLocalStorage());
	const setSelectedClientUsers = users => {
		_setSelectedClientUsers(users);
		const userIds = users && users.map(user => user.user_id);
		setEditingClientUsersLocalStorage(userIds);
		setSelectedClientUserIds(userIds);
	}
  const value = {
    selectedClientUsers,
    setSelectedClientUsers,
    selectedClientUserIds,
    setSelectedClientUserIds
  };
  return <clientUsersFormContext.Provider value={value}>{children}</clientUsersFormContext.Provider>
}

export const useClientUsersFormContext = () => useContext(clientUsersFormContext);

const clientUserLocalStorageKey = "selectedClientUserIds";

// setEditingClientUsersLocalStorage(users: Array<Number> | null): void
export const setEditingClientUsersLocalStorage = userIds => window.localStorage.setItem(clientUserLocalStorageKey, JSON.stringify(userIds));

// getEditingClientUsersLocalStorage(): Array<Number> | null
export const getEditingClientUsersLocalStorage = () => JSON.parse(window.localStorage.getItem(clientUserLocalStorageKey));